import RibbonPanel from './ribbon-panel'
import Ribbon from './ribbon'

export {
  RibbonPanel,
  Ribbon
}



// WEBPACK FOOTER //
// ./src/components/ribbon/index.js